import AccountIcon from '~/shared/assets/icons/account.svg';
import ClusterIcon from '~/shared/assets/icons/cluster.svg';
import InstanceIcon from '~/shared/assets/icons/instance.svg';
import NodeIcon from '~/shared/assets/icons/node.svg';
import RegionIcon from '~/shared/assets/icons/region.svg';
import TagIcon from '~/shared/assets/icons/tag.svg';
import UnattachedIcon from '~/shared/assets/icons/unattached.svg';
import VolumeIcon from '~/shared/assets/icons/volume.svg';

export type EntityIconVariant =
  | 'cluster'
  | 'nodeGroup'
  | 'instance'
  | 'ec2'
  | 'unattached'
  | 'region'
  | 'tag'
  | 'account'
  | 'volume';

const ENTITY_ICON_COMPONENTS = {
  account: AccountIcon,
  cluster: ClusterIcon,
  nodeGroup: NodeIcon,
  instance: InstanceIcon,
  ec2: InstanceIcon,
  unattached: UnattachedIcon,
  region: RegionIcon,
  tag: TagIcon,
  volume: VolumeIcon,
} as const;

interface EntityIconProps {
  variant: EntityIconVariant;
}

export default function EntityIcon({ variant }: EntityIconProps) {
  const key = variant === 'ec2' ? 'instance' : variant;
  const Icon = ENTITY_ICON_COMPONENTS[key];

  if (!Icon) return null;

  return (
    <span className="inline-flex items-center justify-center w-5 h-5 shrink-0" aria-hidden>
      <Icon className="w-5 h-5" />
    </span>
  );
}
